<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Webshell upload
      </template>
      <b-card>
        <hr v-if="dropzone && dropzone.bar_value > 0">
        <b-progress v-if="dropzone && dropzone.bar_value > 0" :max="100" show-value style="width:100%;" :value="dropzone.bar_value"></b-progress>
        <hr>
        <b-progress v-if="dropzone && dropzone.count > 0" :value="(dropzone.done / dropzone.count) * 100" show-value  :max="dropzone.count" :precision="2" style="width:100%;"></b-progress>
        <br>
        <b-button variant="warning" @click="clear" style="width:100%;"> Clear </b-button>
        <hr>
        <p>
          URL : {{dropzoneOptions.url}}
        </p>
        <vue-dropzone
        @vdropzone-error="noti_error"
        @vdropzone-total-upload-progress="noti_progress"
        @vdropzone-success="noti_upload_item"
        @vdropzone-queue-complete="noti_upload_all"
        @vdropzone-file-added="noti_add"

        ref="dropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
      </b-card>

      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            Completed : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Waiting : {{model.disable}}
          </b-badge>
        </b-col>
        <b-col sm="10" class="md-12">
          <!-- <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-btn :disabled="so.adv" :text="so.skt || 'Code'"  size="sm" variant="outline-secondary">Code</b-btn>

            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group> -->
          <br>

          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <b-button class="mx-2" variant="danger" @click="regist_all"> All apply to pattern(SSDEPP/HASH) </b-button>
            <b-button class="mx-2" variant="warning" @click="delete_all"> All apply to delete </b-button>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template>
        <template slot="is_done" slot-scope="row">
          <b-badge variant="success" v-if="row.item.is_done">applyed</b-badge>
          <b-badge v-else variant="secondary">Wait</b-badge>
        </template>
        <template slot="category" slot-scope="row">{{codes.code_category[row.item.category] || row.item.category || '-'}}</template>
        <template slot="name" slot-scope="row">{{ row.item.name }}</template>
        <template slot="source" slot-scope="row">{{row.item.source}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>

      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import groupList from '../../Management/group/Group.List'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import config from '@/config'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  cmd : "search",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

export default {
  components: { DatePicker, vSelect, cSwitch, groupList, vueDropzone },
  name : "webshellRegist",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => {
    return {
      dropzoneOptions: {
          url: location.hostname == 'localhost' ? `${config.baseURL}/upload/wsfinder` : `${location.protocol}//${location.hostname.replace('manager', 'api')}/v1/upload/wsfinder`,
          thumbnailWidth: 150,
          maxFilesize: 20, // unit is
          addRemoveLinks: true,
          parallelUploads : 3,
          chunking : false,
          duplicateCheck : true,
          headers: {
            // 'ContentType' : 'application/json',
            'Authorization' : 'Bearer ' + auth.token
          },
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
      },
      dropzone : { bar_value: 0, count : 0, done : 0 },
      group_name :'',
      custom,
      codes,
      so : default_opt(),
      model : { total : 0, enable : 0, disable : 0 },
      sync : { interval : 15, stop : false, th : undefined },
      id_list : []
    }
  },
  computed: {
    fields : function() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'created_at', label: 'Uploaded_at', sortable: true, thStyle: 'width: 12%' },
        { key: 'is_done', label: 'Status', sortable: true, thStyle: 'width: 12%' },
        { key: 'category', label: 'Category', sortable: true, thStyle: 'width: 15%' },
        { key: 'name', label: 'Filename', sortable: true },
        { key: 'source', label: 'Source', sortable: true, thStyle: 'width: 12%' },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    // start dropzone function
    processing() { return this.$refs.dropzone.processQueue(); },
    clear() {
      this.$refs.dropzone.removeAllFiles();
      this.refresh();
    },
    noti_add(rs) { console.log(rs.name, "loading"); this.dropzone.count += 1; },
    noti_error(rs) { this.$toastr.w(rs.name, "duplicate"); console.log("error : ", rs); this.dropzone.done +=1 },
    noti_progress(rs){ console.log("status : ", rs); this.dropzone.bar_value = rs; },
    noti_upload_item(rs) { this.$toastr.i(rs.name, rs.status); this.$refs.dropzone.removeFile(rs); this.dropzone.done +=1; },
    noti_upload_all() {
      this.$toastr.s("processing", "complated")
      this.refresh();
    },
    async regist_all() {
      if(!this.id_list.length) { return this.$toastr.w("no have data", this.$route.name) }
      Api.Manager({ target : 'wsfinder.webshell.temp', cmd : 'all.apply', body : this.id_list })
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.$toastr.s("completed", this.$route.name); } this.refresh(); })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    async delete_all() {
      if(!this.id_list.length) { return this.$toastr.w("no have data", this.$route.name) }
      Api.Manager({ target : 'wsfinder.webshell.temp', cmd : 'all.delete', body : this.id_list })
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.$toastr.s("completed", this.$route.name); } this.refresh(); })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.refresh(); },
    refresh() {
      console.log('refresh'); this.$refs._list.refresh();
      this.dropzone.bar_value = 0;
      this.dropzone.count = 0;
      this.dropzone.done = 0;
    },
    getItems: function(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        target : 'wsfinder.webshell.temp', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '='}, { name : 'is_alive', value : true, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'type':
              cond = this.set_op(k[i], this.codes.code_type_key[this.so.opt[k[i]]], true);
              break;
            case 'category':
              cond = this.set_op(k[i], this.codes.code_category_key[this.so.opt[k[i]]], true);
              break;
            case 'ext':
              cond = this.set_op(k[i], this.codes.code_ext_key[this.so.opt[k[i]]], true);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if( cond.value == '-' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => {
        this.so.totalRows = rs.total;
        this.id_list = [];

        if (rs.body && rs.body.length) {
          for (let index = 0; index < rs.body.length; index++) { this.id_list.push(rs.body[index].id); }
        }

        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { this.$router.push(`/wsfinder/regist/${item.id}`); },
    summary() {
      let and = [];
      Api.Manager({ target : 'wsfinder.webshell.temp', cmd : 'summary', body : { and : and, or : [], sort : [] } })
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.model = Object.assign(this.model, rs.body) } })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created: function() { console.log('upattern.list.vue', 'created'); },
  destroyed: function() { console.log('upattern.list.vue', 'destroyed'); },
  mounted: function() {
    console.log('upattern.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
